import config from 'devextreme/core/config';
import type { App } from 'vue';
import { MButton } from '@mts/components/Button';
import { MIcon } from '@mts/components/Icon';
import { MPage } from '@mts/components/Page';
import { useRenderComponents } from '@mts/render/components/pc';

config({
  licenseKey:
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjM1NWQ5YjEwLTdiMWItNDNiZC1hZDZkLWI5OGU2ZGFhZDJkMCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.PbwW2rddJNN5sAK84KGQxvASJJAiGQ/mSwWM/I+AuaUg26YTHGmWA97FF368oM/pDuQs1EFw/OaJu/w19fN8VyL1qDKR8/7DJfS9ZKKg0tzb2RIRjog4XSXFmFpxzW7iiQ8s6Q==',
});

/** 注册全局组件 */
export function setupGlobComponents(app: App) {
  app.use(MIcon).use(MButton).use(MPage);

  useRenderComponents(app);
}
